<div class="version-panel">
  @if (!isProduction) {
    <span class="env-label env-dev">{{ environmentName }}</span>
  }
  <span class="version-label">v{{ version }}</span>
</div>
